import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Form from '../../../components/fields/Form';
import ConsolePageWithHeader from '../../../layouts/ConsoleLayout/ConsolePageWithHeader';
import MainDetails from '../InsuranceProductDetails/InsuranceProductDetailsInnerPage/MainDetails';

type InnerProps = {
    handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
};

const Inner = ({ handleSubmit }: InnerProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <ConsolePageWithHeader
            footer={[
                <Button key="submit" form="insuranceProductForm" htmlType="submit" type="primary">
                    {t('insuranceProductDetails:actions.create')}
                </Button>,
            ]}
            onBack={() => navigate('/admin/insuranceProducts')}
            title={t('insuranceProductDetails:addTitle')}
        >
            <Form id="insuranceProductForm" name="insuranceProductForm" onSubmitCapture={handleSubmit}>
                <MainDetails />
            </Form>
        </ConsolePageWithHeader>
    );
};

export default Inner;
